import { CornerIconButton, Button } from "@/src/components/buttons";
import { openDrawer } from "@/src/components/dialogs";
import { Input } from "@/src/components/universalInput";
import {
  OrdonnanceCategory,
  OrdonnanceMedicine,
  Medicine,
  medicineUnits,
  medicineHoraires,
  medicineRoutes,
  taskDurations,
  dilutionSolutions,
  MedicineHoraire,
  ordonnanceDurations,
  Patient,
  Ordonnance,
  FolderItem,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  getUserId,
  getOptionsFromRecord,
  jsonAbstract,
} from "@/src/utils/utils";
import moment from "moment";
import { useState } from "react";
import { IoAdd } from "react-icons/io5";
import { generateTasks } from "./generateTasks";

export function OrdonnanceMedicineForm({
  isTemplate,
  category,
  current,
  onChange,
}: {
  isTemplate: boolean;
  category: OrdonnanceCategory;
  current?: OrdonnanceMedicine;
  onChange: (newValue: OrdonnanceMedicine) => void;
}) {
  const [reload, setReload] = useState(0);
  let [data, setData] = useState(current || ({} as OrdonnanceMedicine));
  function setNewValue(newValue: OrdonnanceMedicine) {
    setData({ ...newValue });
    onChange(newValue);
  }

  let medicine = data.medicine || ({} as Medicine);

  data.intakes ||= [];
  if (data.intakes.length == 0)
    data.intakes.push({
      posology: 1,
      route: medicine.defaultRoute || "orale",
      unit: medicine.defaultUnit || "comprimé",
      horaire: category == "ambulatory" ? "1x/j" : "09:00:00",
      duration: 0,
      dilutionVolume: null,
      solution: null,
      creator: getUserId(),
    });

  return (
    <div className="c1 gap10">
      <div className="grid c1 gap20">
        {data.intakes?.map((intake, index) => {
          if (!intake) return;
          const localInputs = ["posologie", "type", "voie", "horaire"];
          if (isTemplate) localInputs.push("dilution", "volume");
          if (intake?.unit?.includes("/h"))
            localInputs.push("dilution", "volume");
          if (intake?.unit?.includes("/h") == true || isTemplate == true)
            localInputs.push("durée");

          return (
            <div
              key={`intake${index}${reload}`}
              className="fade c1-auto gap10  card "
            >
              {data.intakes?.length != 1 && (
                <div className="bold">Prise {index + 1}</div>
              )}
              {index != 0 && (
                <CornerIconButton
                  type="delete"
                  onClick={() => {
                    if (index == 0) return;
                    data.intakes.splice(index, 1);
                    setNewValue(data);
                    setReload(reload + 1);
                  }}
                ></CornerIconButton>
              )}
              <div className="fade c1 gap10" style={{ alignItems: "end" }}>
                <Input
                  name=""
                  value={intake?.posology}
                  type="text"
                  onChange={(newValue) => {
                    intake.posology = newValue;
                    setNewValue(data);
                  }}
                />
                <Input
                  name=""
                  value={intake?.unit}
                  type="dialogSelect"
                  options={Object.values(medicineUnits).map((item) => {
                    return { value: item.id, label: item.name };
                  })}
                  onChange={(newValue) => {
                    intake.unit = newValue;
                    setNewValue(data);
                  }}
                />
                <Input
                  name={""}
                  value={intake?.horaire}
                  type="dialogSelect"
                  options={Object.values(medicineHoraires)
                    .filter(
                      (item) =>
                        item.types?.includes(category) ||
                        (isTemplate == true && item.types.length == 0)
                    )
                    .map((item) => {
                      return { value: item.id, label: item.name };
                    })}
                  onChange={(newValue) => {
                    intake.horaire = newValue;
                    setNewValue(data);
                  }}
                />
              </div>
              {intake.unit != "comprimé" && intake.unit != "gélule" && (
                <Input
                  name=""
                  value={intake?.route}
                  type="select"
                  options={Object.values(medicineRoutes).map((route) => {
                    return { value: route.id, label: route.name };
                  })}
                  onChange={(newValue) => {
                    intake.route = newValue;
                    setNewValue(data);
                  }}
                />
              )}

              {localInputs.includes("durée") && (
                <Input
                  name={"Durée"}
                  value={intake?.duration?.toString() || "0"}
                  type="select"
                  options={Object.values(taskDurations).map((item) => {
                    return {
                      value: item.minutes?.toString(),
                      label: item.name,
                    };
                  })}
                  onChange={(newValue) => {
                    intake.duration = parseInt(newValue);
                    setNewValue(data);
                  }}
                />
              )}
              {localInputs.includes("dilution") && (
                <Input
                  name={"Dilution"}
                  value={intake?.solution}
                  type="select"
                  options={getOptionsFromRecord(dilutionSolutions)}
                  onChange={(newValue) => {
                    intake.solution = newValue;
                    setNewValue(data);
                  }}
                />
              )}

              {localInputs.includes("volume") && (
                <Input
                  name={"Volume (ml)"}
                  value={intake?.dilutionVolume}
                  type="number"
                  onChange={(newValue) => {
                    intake.dilutionVolume = newValue;
                    setNewValue(data);
                  }}
                />
              )}
            </div>
          );
        })}

        <Button
          type={"tertiary"}
          onClick={() => {
            let lastIntake = data.intakes[data.intakes.length - 1];
            let lastHoraire = lastIntake?.horaire;
            let newHoraire = jsonAbstract(lastHoraire);

            if (lastHoraire?.includes("00:00"))
              newHoraire = moment(lastHoraire || "09:00:00", "HH:mm:ss")
                .add(4, "hour")
                .format("HH:mm:ss");

            data.intakes.push({
              posology: 1,
              unit: lastIntake?.unit || medicine.defaultUnit || "comprimé",
              horaire: newHoraire as MedicineHoraire,
              route: lastIntake?.route || medicine.defaultRoute || "orale",
              duration: 0,
              dilutionVolume: null,
              solution: null,
              creator: getUserId(),
            });
            setNewValue(data);
          }}
        >
          <div className="cauto-1 gap10 acenter">
            <IoAdd size={18} />

            <div className="mright10">Ajouter une prise</div>
          </div>
        </Button>
      </div>

      {category == "hospital" && (
        <Input
          name="A commencer le"
          value={data.startDate}
          type="date"
          onChange={(newValue) => {
            setNewValue({ ...data, startDate: newValue });
          }}
        />
      )}

      <Input
        name="Durée"
        value={data.duration}
        type="select"
        options={Object.values(ordonnanceDurations)?.map((item) => {
          return { value: item.id, label: item.name };
        })}
        onChange={(newValue) => {
          console.log("gonna set", {
            data,
            as: { ...data, duration: newValue },
          });
          setNewValue({ ...data, duration: newValue });
        }}
      />

      <Input
        name="Notes  (optionnel)"
        value={data.notes}
        type="textarea"
        onChange={(newValue) => {
          setNewValue({ ...data, notes: newValue });
        }}
      />

      <div style={{ width: "20px", height: "100px" }}></div>
    </div>
  );
}

export async function openOrdonnanceMedicineForm({
  ordonnanceMedicine,
  medicine,
  patient,
  parent,
  onBeforeConfim,
  onConfirm,
}: {
  ordonnanceMedicine: OrdonnanceMedicine | null | undefined;
  medicine: Medicine;
  patient: Patient;
  parent: FolderItem;
  onBeforeConfim?: (
    ordonnanceMedicine: OrdonnanceMedicine | null | undefined
  ) => Promise<boolean>;
  onConfirm: (
    ordonnanceMedicine: OrdonnanceMedicine | null | undefined
  ) => void;
}) {
  ordonnanceMedicine ||= {
    patient,
    creator: getUserId(),
    intakes: [],
    duration: "10 jours",
    startDate: moment().format("YYYY-MM-DD"),
    medicine,

    notes: "",
    tasks: [],
  };

  await openDrawer({
    title: "Ajouter un médicament",
    additionalClasses: ["small"],
    content: (
      <OrdonnanceMedicineForm
        isTemplate={false}
        category="hospital"
        current={ordonnanceMedicine}
        onChange={(newValue) => {
          ordonnanceMedicine = newValue;
        }}
      />
    ),
    confirmBeforeClose: true,
    onConfirm: async () => {
      if (!ordonnanceMedicine)
        throw new Error("OrdonnanceMedicine n'est pas définie");
      let medicineId = ordonnanceMedicine?.medicine?.id;

      if ((await onBeforeConfim?.(ordonnanceMedicine)) === false) return;

      ordonnanceMedicine.tasks = generateTasks({
        ordonnanceMedicine,
        parent,
        patient,
      });

      let ordonnance: Ordonnance = {
        creator: getUserId(),
        parent,
        patient,
        category: "hospital",
        ordonnanceMedicines: [ordonnanceMedicine],
      };

      let res = await apiFetch(
        "ordonnances",
        "addOne",
        {
          ordonnance,
        },
        "Erreur lors de la création de l'ordonnance"
      );
      onConfirm(ordonnanceMedicine);
    },
  });
}
